import React, { useContext } from "react";
import { graphql } from "gatsby";
import { LinkBar } from "./LinkBar";
import {
  KontentComponentLayout,
  KontentComponentSettings,
  KontentLinks,
} from "../../../types";
import { getComponentSettings } from "../../../lib/componentSettings";
import { formatLinks } from "../../../lib/links";
import { PageMetadataContext } from "../../../templates/Page/PageContext";

interface Props extends KontentComponentLayout, KontentComponentSettings {
  link_configuration__link: KontentLinks;
}

const LinkBarContainer: React.FC<Props> = ({
  link_configuration__link,
  ...props
}) => {
  const pageLocation = useContext(PageMetadataContext).location;

  const settings = getComponentSettings({ ...props });
  const links = formatLinks(link_configuration__link.modular_content).map(
    (link) => ({ ...link, active: link.href === pageLocation?.pathname })
  );

  return <LinkBar {...settings} links={links}></LinkBar>;
};

export default LinkBarContainer;

export const fragmentLinkBarContainer = graphql`
  fragment LinkBar on kontent_item_link_bar {
    elements {
      link_configuration__link {
        modular_content {
          ...kontentRichTextLink
        }
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_layout__component_width {
        value {
          codename
        }
      }
    }
  }
`;
